export const IconCloud = () => (
  <svg aria-hidden='true' width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10 0C13.5201 0 15.517 2.27298 15.8075 5.01799L15.8963 5.01798C18.1616 5.01798 19.9981 6.80482 19.9981 9.00899C19.9981 11.2132 18.1616 13 15.8963 13H11.7392L11.7386 8.96466L12.7133 9.94048L12.8533 10.0614L12.8829 10.0834C13.5688 10.5922 14.5405 10.5367 15.1625 9.91476C15.8459 9.23135 15.8459 8.12331 15.1625 7.43989L11.2115 3.48892L11.0717 3.36823L11.042 3.34623C10.3562 2.83736 9.38444 2.89291 8.76252 3.51483L4.81155 7.4658L4.69087 7.60559L4.66887 7.63524C4.16 8.32107 4.21554 9.29284 4.83746 9.91476L4.86337 9.94067L5.00317 10.0614L5.03281 10.0834C5.71864 10.5922 6.69051 10.5366 7.31243 9.91467L8.24059 8.98625L8.24008 13H4.10372C1.83838 13 0.00195312 11.2132 0.00195312 9.00899C0.00195312 6.80482 1.83838 5.01798 4.10375 5.01798L4.19256 5.01799C4.48467 2.25494 6.47989 0 10 0ZM9.24089 6.57135L9.23972 16.2562C9.23972 16.6704 9.57551 17.0062 9.98972 17.0062C10.4039 17.0062 10.7397 16.6704 10.7397 16.2562L10.7383 6.54813L13.3947 9.20766L13.4788 9.28027C13.4979 9.29444 13.5175 9.30758 13.5376 9.3197C13.585 9.34835 13.6349 9.37128 13.6863 9.38849C13.9475 9.47598 14.2474 9.41572 14.4554 9.20768C14.7483 8.91479 14.7483 8.43991 14.4554 8.14702L10.5303 4.22196L10.4462 4.14934C10.4044 4.11827 10.36 4.09213 10.3139 4.07091C10.0368 3.94328 9.69794 3.99362 9.46963 4.22193L5.54456 8.147L5.47195 8.23111C5.25409 8.52472 5.2783 8.94139 5.54456 9.20766L5.62868 9.28027C5.64703 9.29389 5.66586 9.30655 5.6851 9.31828C5.73321 9.34759 5.78392 9.371 5.83617 9.38849C6.0974 9.47598 6.39724 9.41572 6.60528 9.20768L9.24089 6.57135Z'
      fill='#219AFD'
    />
  </svg>
)

export const IconTrash = () => (
  <svg aria-hidden='true' width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_8380_94500)'>
      <path d='M4 7.5H20' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M10 11.5V17.5' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M14 11.5V17.5' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M5 7.5L6 19.5C6 20.0304 6.21071 20.5391 6.58579 20.9142C6.96086 21.2893 7.46957 21.5 8 21.5H16C16.5304 21.5 17.0391 21.2893 17.4142 20.9142C17.7893 20.5391 18 20.0304 18 19.5L19 7.5'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 7.5V4.5C9 4.23478 9.10536 3.98043 9.29289 3.79289C9.48043 3.60536 9.73478 3.5 10 3.5H14C14.2652 3.5 14.5196 3.60536 14.7071 3.79289C14.8946 3.98043 15 4.23478 15 4.5V7.5'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_8380_94500'>
        <rect width='24' height='24' fill='white' transform='translate(0 0.5)' />
      </clipPath>
    </defs>
  </svg>
)
